import React from 'react';

const TrendDownIcon = () => {
  return (
    <svg
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.3359 18.4163H23.8359V11.9163'
        stroke='#FF0500'
        stroke-width='2.16667'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M23.8307 18.4171L14.6224 9.20874L9.20573 14.6254L2.16406 7.58374'
        stroke='#FF0500'
        stroke-width='2.16667'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export default TrendDownIcon;
